import React from 'react';
import { Collapse, List, ListItem, ListItemText, styled } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { NavLink, useLocation } from 'react-router-dom';

const Wrapper = styled('div')({
  '& .active': {
    color: '#5564F8'
  },
  '& a': {
    color: 'inherit',
    textDecoration: 'none'
  }
});

const StyledList = styled(List)(({ depth }) => ({
  '& .MuiTypography-root': {
    fontSize: '0.75rem'
  },
  '& .active': {
    borderLeft: '2px solid #5564F8',
    marginLeft: '-1px'
  },
  borderLeft: '1px solid #9BA0AD',
  marginLeft: `${(depth + 1) * 1.3}rem`
}));

const NavigationItem = ({ item, expandedItems, setExpanded, depth = 0 }) => {
  const { name, children, isDisabled, id, url } = item;
  const hasChildren = Array.isArray(children) && children.length > 0;
  const onToggle = (id) => {
    setExpanded((prev) => {
      const isRemoving = prev.includes(id);

      return isRemoving ? prev.filter((item) => item !== id) : [...prev, id];
    });
  };

  const isExpanded = expandedItems.includes(id);
  const isExternalLink = id === 'chat' || id === 'transactions-v2';

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const p = queryParams.get('id');

  const externalUrl = p ? `${url}?p=${p}` : url;

  const ListItemLink = isExternalLink && (
    <a
      className="uiButtonBase-root MuiListItem-root MuiListItem-gutters MuiListItem-button"
      href={externalUrl}
      rel="noopener noreferrer"
      target="_blank"
    >
      <ListItemText primary={name} />
      <span className="MuiTouchRipple-root" />
    </a>
  );

  return (
    <Wrapper>
      {hasChildren ? (
        <>
          <ListItem button disabled={isDisabled} onClick={() => onToggle(id)}>
            <ListItemText primary={name} />
            {isExpanded ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <StyledList component="div" depth={depth}>
              {children
                .filter((item) => item.isVisible)
                .map((item) => (
                  <NavigationItem
                    key={item.id}
                    depth={depth + 1}
                    expandedItems={expandedItems}
                    item={item}
                    setExpanded={setExpanded}
                  />
                ))}
            </StyledList>
          </Collapse>
        </>
      ) : (
        <ListItem
          button
          component={isExternalLink ? () => ListItemLink : NavLink}
          disabled={isDisabled}
          onClick={() => onToggle(id)}
          to={!isExternalLink ? url : undefined}
        >
          {isExternalLink ? ListItemLink : <ListItemText primary={name} />}
        </ListItem>
      )}
    </Wrapper>
  );
};

export default NavigationItem;
